import { Text, Colors } from '@mercator-gcp/grout';

const headerStyle = {
  padding: 'padding_8',
  paddingBottom: '0',
};

type HeaderProps = {
  label: string;
};

const Header = ({ label }: HeaderProps) => {
  return (
    <Text.SmallLabel sx={headerStyle} color={Colors.TextQuiet}>
      {label}
    </Text.SmallLabel>
  );
};

export default Header;
